import { definePreset, palette } from '@primeuix/themes';
import { button } from './components/button';
import { colors } from './colors';
import { datatable } from './components/datatable';
import Aura from '@primeuix/themes/aura';
import { progressspinner } from './components/progressspiner';
import { toast } from './components/toast';
import { popover } from './components/popover';
import { select } from './components/select';
import { fileupload } from './components/fileupload';
import { dialog } from './components/dialog';
import { textarea } from './components/textarea';
import { inputtext } from './components/inputtext';
import { tooltip } from './components/tooltip';
import { multiselect } from './components/multiselect';
import { checkbox } from './components/checkbox';
import { paginator } from './components/paginator';
import { autocomplete } from './components/autocomplete';
import { menu } from './components/menu';
import { confirmpopup } from './components/confirmpopup';
import { accordion } from './components/accordion';
import { togglebutton } from './components/togglebutton';
import { toggleswitch } from './components/toggleswitch';
import { tabs } from './components/tabs';

export const BlindspotPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      dark: {
        primary: palette(colors.primary),
        surface: palette(colors.surface),
        content: {
          background: '{blue.500}',
          borderColor: colors.border,
        },
        text: {
          color: 'white',
          weakColor: colors.textWeak,
          mutedColor: '{surface.200}',
        },
        formField: {
          background: '{blue.500}',
          placeholderColor: '{text.weakColor}',
          iconColor: '{text.weakColor}',
          disabledBackground: '{blue.500}',
        },

        blue: {
          50: colors.blue50,
          100: colors.blue100,
          200: colors.blue200,
          300: colors.blue300,
          400: colors.blue400,
          500: colors.blue500,
        },
      },
    },
  },
  components: {
    accordion,
    button,
    datatable,
    progressspinner,
    toast,
    popover,
    select,
    multiselect,
    fileupload,
    dialog,
    textarea,
    inputtext,
    tooltip,
    checkbox,
    paginator,
    autocomplete,
    menu,
    confirmpopup,
    togglebutton,
    toggleswitch,
    tabs,
  },
});
